'use client';

import React from 'react';
import { BlockProps } from './types';
import { HtmlContent } from '@/core/components/ui/HtmlContent';

export function CategoryHeaderBlock({ block, currentStyles, isAdmin, category, viewport }: BlockProps) {
  const settings = block.settings || {};

  const name = category?.name ?? (isAdmin ? 'Nazwa kategorii' : null);
  const description = category?.description ?? (isAdmin ? 'Przykładowy opis kategorii, widoczny pod nagłówkiem.' : null);

  if (!name) return null;

  const showDescription = settings.showDescription ?? true;
  const alignment: 'left' | 'center' = settings.alignment === 'left' ? 'left' : 'center';

  const titleFontSize = currentStyles.titleFontSize ? `${currentStyles.titleFontSize}px` : undefined;
  const titleFontWeight = currentStyles.titleFontWeight || '900';
  const titleColor = currentStyles.titleColor || '#0f172a'; // slate-900
  const descriptionColor = currentStyles.descriptionColor || '#475569'; // slate-600

  const level = settings.level || 'h1';
  const HeaderTag = level as any;
  const defaultFontSize = level === 'h1' ? 'clamp(2rem, 4vw, 3rem)' : level === 'h2' ? 'clamp(1.5rem, 3vw, 2.25rem)' : 'clamp(1.25rem, 2.5vw, 1.75rem)';
  // Admin canvas simulates viewport by scaling a real-width div — the `vw` unit above
  // resolves against the real browser window, not that scaled width, so the clamp() always
  // reads as if on a wide desktop regardless of the viewport toggle. Each clamp()'s min bound
  // is what it actually evaluates to at both 375px (mobile) and 768px (tablet) — the fluid
  // part only kicks in above ~800px — so only desktop needs its own (max-bound) value here.
  const defaultFontSizeAdmin = viewport === 'desktop'
    ? (level === 'h1' ? '3rem' : level === 'h2' ? '2.25rem' : '1.75rem')
    : (level === 'h1' ? '2rem' : level === 'h2' ? '1.5rem' : '1.25rem');

  return (
    <header
      className="w-full relative z-10 block-inner-content mb-6"
      style={{ textAlign: alignment }}
    >
      <HeaderTag
        className="tracking-tight mb-4 transition-all"
        style={{
          fontSize: titleFontSize || (isAdmin ? defaultFontSizeAdmin : defaultFontSize),
          fontWeight: titleFontWeight,
          color: titleColor,
        }}
      >
        {name}
      </HeaderTag>
      {showDescription && description && (
        <HtmlContent
          html={description}
          className={alignment === 'center' ? 'prose prose-slate max-w-4xl mx-auto' : 'prose prose-slate max-w-4xl'}
          style={{ color: descriptionColor }}
        />
      )}
    </header>
  );
}
